import { QueryFunctionContext, useQuery } from 'react-query';
import {
  marketCountryKeys,
  parseMarketCountryKey,
} from '../cache-keys/marketCountryKeys';
import { useAPI } from '@axo/shared/data-access/provider';
import { lender_api } from '@axo/shared/data-access/api';
import { queryFunction } from '../query-function';

function map({
  queryKey,
}: QueryFunctionContext<ReturnType<(typeof marketCountryKeys)['banks']>>) {
  const query = parseMarketCountryKey(queryKey);
  return query.marketCountry;
}

export function useLenders(marketCountry?: string) {
  const api = useAPI();
  const cacheKey = marketCountryKeys.banks({
    marketCountry: marketCountry ?? '',
  });

  return useQuery(cacheKey, queryFunction(lender_api.getLenders(api), map), {
    enabled: marketCountry !== undefined,
  });
}
